<mat-card appearance="outlined">
    <mat-card-content>
        @if (hasPanels) {
            <icc-select-box
                [title]="'DOOR|Panel wypełnieniowy' | translate"
                [description]="selectedPanel?.name"
                [imageUrl]="selectedPanel?.image ? ('/files/filling/' + selectedPanel.image) : ''"
                [buttonText]="'INTERFACE|Zmień' | translate"
                [disabledButton1]="pageData.panels.length <= 1"
                (select)="changePanel()"
            ></icc-select-box>
        }
        @if (hasGlazings) {
            <icc-select-box
                [title]="'DOOR|Szklenie' | translate"
                [description]="selectedGlazing?.name"
                [imageUrl]="selectedGlazing?.image ? ('/files/filling/' + selectedGlazing.image) : ''"
                [buttonText]="'INTERFACE|Zmień' | translate"
                [disabledButton1]="pageData.glazings.length <= 1"
                (select)="changeGlazing()"
            ></icc-select-box>
        }
    </mat-card-content>
    <mat-card-actions>
        <button mat-raised-button color="primary" (click)="save()">
            {{ 'INTERFACE|OK' | translate }}
        </button>
    </mat-card-actions>
</mat-card>
